import { render, staticRenderFns } from "./Recurring-Listing-Template.vue?vue&type=template&id=28da4da1"
import script from "./Recurring-Listing-Template.vue?vue&type=script&lang=js"
export * from "./Recurring-Listing-Template.vue?vue&type=script&lang=js"
import style0 from "./Recurring-Listing-Template.vue?vue&type=style&index=0&id=28da4da1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports